import { Button, Divider, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { NavLink } from 'react-router-dom';

export const HomePageEndOfMonthHeader: React.FC = () => {
  const latestBillingCycleMonth = dayjs().utc().format('MMMM');
  const thisYear = dayjs().year();

  return (
    <Stack
      direction="row"
      component="section"
      alignItems="center"
      gap={2}
    >
      <Typography variant='h6'>End of Month Closure</Typography>

      <Divider
        orientation='vertical'
        flexItem
        sx={{ 
          marginTop: '2px', 
          marginBottom: '7px', 
        }}
      />
      <Typography
        color={(theme) => theme.palette.text.secondary}
        variant='subtitle1'
      >
        {`${latestBillingCycleMonth} ${thisYear}`}
      </Typography>

      <Button
        component={NavLink}
        to='../../invoices/monthly-approval'
        sx={{
          marginLeft: 'auto',
        }}
        variant='contained'
      >
        Go to Monthly Report
      </Button>
    </Stack>
  );
};